import * as React from 'react';
import devWarning from 'antd/es/_util/devWarning';
import collapseMotion from 'antd/es/_util/motion';
import { cloneElement } from 'antd/es/_util/reactNode';
import { ConfigConsumer } from 'antd/es/config-provider';
import { SiderContext } from 'antd/es/layout/Sider';
import classNames from 'classnames';
import RcMenu, { Divider, ItemGroup } from 'rc-menu';
import MenuContext from './MenuContext';
import Item from './MenuItem';
import SubMenu from './SubMenu';
class InternalMenu extends React.Component {
    constructor(props) {
        super(props);
        this.renderMenu = ({ getPopupContainer, getPrefixCls, direction }) => {
            const rootPrefixCls = getPrefixCls();
            const { prefixCls: customizePrefixCls, className, theme, expandIcon = null } = this.props;
            const defaultMotions = {
                horizontal: { motionName: `${rootPrefixCls}-slide-up` },
                inline: collapseMotion,
                other: { motionName: `${rootPrefixCls}-zoom-big` }
            };
            const prefixCls = getPrefixCls('menu', customizePrefixCls);
            const menuClassName = classNames(`${prefixCls}-${theme}`, {
                [`${prefixCls}-inline-collapsed`]: this.getInlineCollapsed()
            }, className);
            return (React.createElement(MenuContext.Provider, { value: {
                    inlineCollapsed: this.getInlineCollapsed() || false,
                    antdMenuTheme: theme,
                    direction
                } },
                React.createElement(RcMenu, Object.assign({ getPopupContainer: getPopupContainer }, this.props, { className: menuClassName, prefixCls: prefixCls, direction: direction, defaultMotions: defaultMotions, expandIcon: cloneElement(expandIcon, {
                        className: `${prefixCls}-submenu-expand-icon`
                    }) }))));
        };
        devWarning(!('inlineCollapsed' in props && props.mode !== 'inline'), 'Menu', '`inlineCollapsed` should only be used when `mode` is inline.');
        devWarning(!(props.siderCollapsed !== undefined && 'inlineCollapsed' in props), 'Menu', '`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead.');
    }
    getInlineCollapsed() {
        const { inlineCollapsed, siderCollapsed } = this.props;
        if (siderCollapsed !== undefined) {
            return siderCollapsed;
        }
        return inlineCollapsed;
    }
    render() {
        return React.createElement(ConfigConsumer, null, this.renderMenu);
    }
}
InternalMenu.defaultProps = {
    className: '',
    theme: 'light',
    focusable: false
};
// We should keep this as ref-able
class Menu extends React.Component {
    render() {
        return (React.createElement(SiderContext.Consumer, null, (context) => React.createElement(InternalMenu, Object.assign({}, this.props, context))));
    }
}
Menu.Divider = Divider;
Menu.Item = Item;
Menu.SubMenu = SubMenu;
Menu.ItemGroup = ItemGroup;
export default Menu;
